import { Typography } from '@material-ui/core'
import * as React from 'react'
import {
  Breakpoint,
  getBreakpointClassName,
  getBreakpointsArr
} from '../../../data/abitilies/Breakpoint'
import ISpecCategory from '../../../data/abitilies/interfaces/ISpecCategory'
import { RelevantSpecialist } from '../RelevantSpecialist'

import { getLastWordFromString } from 'services/utils'
import './style.scss'

interface IProps {
  specCatg: ISpecCategory
}

interface IState {
  isOpen: boolean
}

export class SpecCategory extends React.Component<IProps, IState> {
  state: IState = {
    isOpen: false
  }

  toggleIsOpen = () =>
    this.setState(prevState => ({ isOpen: !prevState.isOpen }))

  render() {
    const {
      specCatg: { title, ranges }
    } = this.props
    const { isOpen } = this.state

    const { last, rest } = getLastWordFromString(title)

    return (
      <div className={'spec-category' + (isOpen ? ' active' : '')}>
        <Typography
          className={'spec-category-title' + (isOpen ? ' active' : '')}
          onClick={this.toggleIsOpen}
        >
          {rest}
          {rest && last && ' '}
          <span className="last-word">
            {last}
            <img
              src={require('../../../assets/img/more_black.svg')}
              className={'more-img' + (isOpen ? ' active' : '')}
            />
          </span>
        </Typography>
        <ul className={'ranges' + (isOpen ? ' active' : '')}>
          {ranges.map((c, i) => {
            const { range, specialists } = c
            const mid = (range.end + range.start) / 2
            const closest =
              getBreakpointsArr().sort(
                (a, b) => Math.abs(a - mid) - Math.abs(b - mid)
              )[0] || Breakpoint.Average
            return (
              <div key={i} className="range">
                <Typography
                  className={`range-title ${getBreakpointClassName(closest)}`}
                >
                  {range && `Score ${range.start}-${range.end}:`}
                </Typography>
                {specialists.map((s, j) => (
                  <RelevantSpecialist specialist={s} key={j} />
                ))}
              </div>
            )
          })}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Abilities/SpecCategory/index.tsx